import { useHistory } from "react-router";
import React, { useState } from "react";
import { Box, Modal, SxProps, Theme, Typography, useTheme } from "@mui/material";
import AlertModel from "../components/investorOverview/common/AlertModel";

interface InitialProps {
    array: Array<{
        name: string
        path: string
        warning?: boolean
        state?: any,
        search?: string
        textSx?: SxProps<Theme>,
        isTextLowerCase?: boolean;
        handleClick?: () => void
    }>;
}

const BreadCrum = (props: InitialProps) => {
    const { array } = props
    const { palette, typography } = useTheme()
    const history = useHistory();
    const [open, setOpen] = useState(false)
    const [replacePath, setReplacePath] = useState({
        path: '',
        state: {},
        search: ''
    })

    const handleRouter = async (item: {
        name: string
        path: string
        warning?: boolean
        state?: any
        search?: string,
        handleClick?: () => void
    }) => {
        if (item?.handleClick && !item.warning) await item?.handleClick()

        if (item.warning) {
            setOpen(true)
            setReplacePath((pre: any) => ({
                path: item.path,
                state: item?.state || {},
                search: item?.search || ""
            }))
        } else {
            setOpen(false)
            history.replace({ pathname: item.path, state: item?.state || {}, search: item?.search || "" })
        }
    }


    const handleClose = () => {
        setOpen(false)
    }

    const handleConfirm = () => {
        const dummy = [...array].filter((item) => item.path === replacePath?.path)[0]

        dummy.handleClick && dummy.handleClick()

        setOpen(false)
        history.replace({ pathname: replacePath.path, state: replacePath?.state || {}, search: replacePath?.search || "" })
    }


    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px', flexWrap: 'wrap' }}>
                {array.map((item, index) => (
                    <Box key={index} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '1px' }}>
                        <Box component={'button'}
                            onClick={() => index === array.length - 1 ? null : handleRouter(item)}
                            sx={{
                                border: 'none',
                                background: 'transparent',
                                fontFamily: typography.fontFamily,
                                color: index === array.length - 1 ? palette.text.secondary : palette.primary[500],
                                fontSize: 14,
                                fontWeight: 500,
                                textWrap: 'nowrap',
                                cursor: index === array.length - 1 ? "not-allowed" : 'pointer',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                maxWidth: { xs: index === array.length - 1 ? 'fit-content' : '100px', sm: '150px', md: 'fit-content', lg: 'fit-content' },
                                width: '100%',
                                textTransform: 'capitalize',
                                ...(item?.textSx || {}),
                            }}>
                            {(item?.isTextLowerCase ?? true) ? `${item?.name?.toLowerCase()}` : item?.name}
                        </Box>
                        <Typography color={index === array.length - 1 ? palette.text.secondary : palette.primary[500]}>
                            {`${index === array?.length - 1 ? '' : '/'}`}
                        </Typography>
                    </Box>

                ))}
            </Box>
            {open &&
                <AlertModel
                    {...{
                        handleClose,
                        handleConfirm,
                        confirmBtnText: 'Go Back Anyway',
                        open,
                        setOpen,
                        title: 'Data not saved, will be lost!',
                        desc: 'Going back will result in loss of your entered data. Are you sure you want to proceed?',
                    }}
                />
            }
        </>
    )
}

export default BreadCrum